var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80764 2.05752C5.8657 1.99931 5.93467 1.95314 6.0106 1.92163C6.08653 1.89012 6.16793 1.8739 6.25014 1.8739C6.33235 1.8739 6.41375 1.89012 6.48968 1.92163C6.56561 1.95314 6.63458 1.99931 6.69264 2.05752L14.1926 9.55752C14.2508 9.61558 14.297 9.68455 14.3285 9.76048C14.36 9.83641 14.3763 9.91781 14.3763 10C14.3763 10.0822 14.36 10.1636 14.3285 10.2396C14.297 10.3155 14.2508 10.3845 14.1926 10.4425L6.69264 17.9425C6.57528 18.0599 6.41611 18.1258 6.25014 18.1258C6.08417 18.1258 5.925 18.0599 5.80764 17.9425C5.69028 17.8252 5.62435 17.666 5.62435 17.5C5.62435 17.3341 5.69028 17.1749 5.80764 17.0575L12.8664 10L5.80764 2.94252C5.74944 2.88446 5.70326 2.81549 5.67175 2.73956C5.64024 2.66363 5.62402 2.58223 5.62402 2.50002C5.62402 2.41781 5.64024 2.33641 5.67175 2.26048C5.70326 2.18455 5.74944 2.11558 5.80764 2.05752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.716734fb1478bf05743d1a7730f21742.svg";
export { ForwardRef as ReactComponent };